import { useBooleanFlagValue } from '@openfeature/react-sdk';

/**
 * The identity broker's switch for the Auth0 onboarding gate, read here for
 * the hosted onboarding page's own behaviour (the page follows the display
 * language the country implies, as the in-app flow does). The same switch
 * decides whether anyone is sent to the page at all. Default OFF. The page is
 * pre-login, so the Flagsmith environment default is what is read.
 * `NEXT_PUBLIC_FORCE_ENABLE_ALL_FEATURE_FLAGS` only patches PostHog, so it is
 * honoured here explicitly, as the other pre-login flags do.
 */
export const AUTH0_ONBOARDING_GATE_FLAG_KEY = 'release-auth0-onboarding-gate';

export const useIsAuth0OnboardingGateEnabled = () => {
  const fromFlagsmith = useBooleanFlagValue(AUTH0_ONBOARDING_GATE_FLAG_KEY, false);
  if (process.env.NEXT_PUBLIC_FORCE_ENABLE_ALL_FEATURE_FLAGS === 'true') return true;
  return fromFlagsmith;
};
